export type ParsedTireSize = {
  width: string;
  height: string;
  dimension: string;
};

/**
 * Detect passenger tire size strings like 195/65R15, 195/65r15, 195/65-15.
 * Returns null for TecDoc-style article numbers (e.g. ox188d).
 */
export const parseTireSize = (input: string): ParsedTireSize | null => {
  if (!input || typeof input !== "string") return null;

  const normalized = input.trim().toUpperCase().replace(/\s+/g, "");
  if (!normalized) return null;

  const match = normalized.match(
    /^(\d{3})\/(\d{2,3})[RZ\-]?(\d{2}(?:\.\d)?)$/
  );
  if (!match) return null;

  return {
    width: match[1],
    height: match[2],
    dimension: match[3],
  };
};

export const formatTireSizeLabel = (size: ParsedTireSize): string =>
  `${size.width}/${size.height}R${size.dimension}`;
